import { render, staticRenderFns } from "./ModalInviteMembers.vue?vue&type=template&id=65ca8f96"
import script from "./ModalInviteMembers.vue?vue&type=script&lang=js"
export * from "./ModalInviteMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports